package fyi.moko.hotpl.data.network

import kotlinx.serialization.Serializable

// --- OpenStreetMap Nominatim /search and /lookup responses (format=jsonv2) ---
// https://nominatim.org/release-docs/latest/api/Search/ — lat/lon are strings, not numbers.

@Serializable
data class NominatimResult(
    val osm_type: String,
    val osm_id: Long,
    val lat: String,
    val lon: String,
    val display_name: String,
    val name: String? = null,
    /** OSM key/value pair for the feature (e.g. `amenity`/`cafe`) — see [osmTypeTags]. */
    val category: String? = null,
    val type: String? = null,
    val extratags: NominatimExtraTags? = null,
)

@Serializable
data class NominatimExtraTags(
    val phone: String? = null,
    val website: String? = null,
)
